export default "__VITE_ASSET__DifrvFLx__"